import { Link } from "react-router-dom";
import { Mail, Instagram } from "lucide-react";
import { Brand, CONTACT_EMAIL, INSTAGRAM_HANDLE, INSTAGRAM_URL } from "./brand";

const legalLinks = [
  { label: "Aviso Legal", to: "/aviso-legal" },
  { label: "Política de Privacidad", to: "/politica-de-privacidad" },
  { label: "Política de Cookies", to: "/politica-de-cookies" },
];

export const FooterBrand = () => (
  <div>
    <Link to="/" data-testid="footer-home-link" className="text-lg text-white"><Brand /></Link>
    <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
      Diseño de páginas web profesionales para negocios pequeños y medianos.
    </p>
    <div className="mt-6 flex gap-3">
      <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email" aria-label="Enviar email a WebEssence"
        className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-zinc-300 transition-colors hover:border-[#00E5FF] hover:text-[#00E5FF]">
        <Mail className="h-4 w-4" />
      </a>
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram de WebEssence"
        className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-zinc-300 transition-colors hover:border-[#00E5FF] hover:text-[#00E5FF]">
        <Instagram className="h-4 w-4" />
      </a>
    </div>
  </div>
);

export const FooterLegalLinks = () => (
  <div>
    <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500">Legal</h4>
    <ul className="mt-4 space-y-3">
      {legalLinks.map((link) => (
        <li key={link.to}>
          <Link to={link.to} data-testid={`footer-${link.to.slice(1)}`} className="text-sm text-zinc-300 transition-colors hover:text-white">{link.label}</Link>
        </li>
      ))}
      <li>
        <button data-testid="footer-configure-cookies" onClick={() => window.dispatchEvent(new Event("we-open-cookies"))}
          className="text-sm text-zinc-300 transition-colors hover:text-white">Configurar cookies</button>
      </li>
    </ul>
  </div>
);

export const FooterContact = () => (
  <div>
    <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500">Contacto</h4>
    <ul className="mt-4 space-y-3 break-words text-sm text-zinc-300">
      <li data-testid="footer-contact-email">{CONTACT_EMAIL}</li>
      <li data-testid="footer-contact-instagram">{INSTAGRAM_HANDLE}</li>
    </ul>
  </div>
);